import { render, staticRenderFns } from "./WeiJueRules.vue?vue&type=template&id=0d2bb29a&scoped=true&"
import script from "./WeiJueRules.vue?vue&type=script&lang=ts&"
export * from "./WeiJueRules.vue?vue&type=script&lang=ts&"
import style0 from "./WeiJueRules.vue?vue&type=style&index=0&id=0d2bb29a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bb29a",
  null
  
)

export default component.exports